import React, { useState } from 'react';
import './Hero.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Hero = () => {
  const profileRef = useScrollAnimation(0);
  const imageRef = useScrollAnimation(200);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-content">
        <div className="profile-section scroll-animate" ref={profileRef}>
          <div className="profile-header">
            <h1 className="name">Pisun Chen</h1>
            <h2 className="title">Software Developer & Computer Science and Business Graduate</h2>
          </div>
          <div className="profile-bio">
            <p className="bio">
              I'm a graduate from UBC passionate about leveraging technology to solve complex problems. My experience working at Alida and Trulioo have strengthened my technical skills and reinforced my passion for creating innovative and impactful solutions. When I'm not coding, you can find me hiking, cyling around Stanley Park, or exploring Vancouver's food scene.
            </p>
          </div>
          <div className="profile-social">
            <div className="social-links" aria-label="Profile links">
              <a
                href="https://linkedin.com/in/pisun"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
                title="LinkedIn"
              >
                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" width="32" height="32" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a
                href="https://github.com/pisunchen"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="GitHub"
                title="GitHub"
              >
                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" width="32" height="32" aria-hidden="true">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a
                href="mailto:pisun.c.l@gmail.com"
                className="social-link"
                aria-label="Email"
                title="Email"
              >
                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" width="32" height="32" aria-hidden="true">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </a>
            </div>
            <div className="resume-button-container">
              <a
                href={`${process.env.PUBLIC_URL}/assets/resume.pdf`}
                download="Pisun_Chen_Resume.pdf"
                className="resume-button"
                aria-label="Download Resume"
              >
                DOWNLOAD RESUME
              </a>
            </div>
          </div>
        </div>
        <div className="hero-illustration scroll-animate" ref={imageRef}>
          <div className="profile-image-container">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/profile.png`} 
              alt="Pisun Chen - Software Developer" 
              className={`profile-image ${imageLoaded ? 'loaded' : ''}`}
              loading="lazy"
              decoding="async"
              onLoad={handleImageLoad}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
